<template>
  <div class="dashboard-container">
    <DashboardGreeting :message="loadMessage()" :name="userName" />
    <div class="d-container">
      <!-- First Container -->
      <div class="sub-container sub-container-1">
        <!-- Banner -->
        <div class="main-heading">
          <SalesEstimate />
        </div>
        <!-- Recent Transaction -->
        <RecentTransactions :transactions="transactionFiltered" />
        <div v-if="loading" class="t-loader">
          <div class="four-dots"></div>
        </div>
      </div>

      <!-- Second Container -->
      <div class="sub-container sub-container-2">
        <!-- All Invoices -->
        <Invoice />
        <!-- Tools -->
        <Tools />
      </div>
    </div>
  </div>
</template>

<script>
import "./merchantDashboard/dashboard.css";
import Tools from "./merchantDashboard/Tools.vue";
import Invoice from "./merchantDashboard/Invoice.vue";
import DashboardGreeting from "./merchantDashboard/DashboardGreeting.vue";
import SalesEstimate from "./merchantDashboard/SalesEstimate.vue";
import RecentTransactions from "./merchantDashboard/RecentTransactions.vue";
import TransactionSearchMixin from "../../../components/transaction/TransactionSearchMixin";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  name: "dashboard",
  mixins: [TransactionSearchMixin],
  components: {
    DashboardGreeting,
    SalesEstimate,
    RecentTransactions,
    Tools,
    Invoice
  },
  data() {
    return {
      tabIndex: 0,
      tabIndex2: 0,
      validTransactions: {
        Refund: true,
        AuthorizeApproved: true,
        Collected: true,
        PartialRefund: true
      }
    };
  },
  computed: {
    transactionFiltered() {
      return this.transactions.filter(
        t => this.validTransactions[t.transactionStatus] && t
      );
    },
    userName() {
      let name = this.$store.getters.userName;
      if (!!name) return name;
      name = this.$store.getters.userEmail;
      if (!!name) return name;
      return "User";
    },
    welcomeMessage() {
      return `Welcome, ${this.userName}`;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  methods: {
    loadMessage() {
      const date = new Date();
      const hours = date.getHours();
      let message;

      if (hours < 12) {
        message = "Good Morning";
      } else if (hours < 18) {
        message = "Good Afternoon";
      } else {
        message = "Good Evening";
      }

      return message;
    },

    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    }
  },
  async created() {
    this.searchEvent().catch(error => {
      this.$logger.error(error);
    });
  }
};
</script>
